// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1nnfs","additionalInfo":"AgreementModal_additionalInfo__3BsW-"};